import {api} from '../../utils/api'

export default {

    /**
     * get users
     * @param commit
     * @param wid
     * @returns {*|Promise|Promise<any>}
     */
    loadUsers({commit}, wid) {
        return api.call(commit, 'get', `/api/workspace/${wid}/users`, false, 'SET_WSUSERS');
    },

    /**
     * get team
     * @param commit
     * @param tid
     * @returns {*|Promise|Promise<any>}
     */
    loadTeam({commit}, tid) {
        return api.call(commit, 'get', `/api/workspace/team/${tid}`, false, 'SET_WSUSERS');
    },


    /**
     * Register new user
     * @param commit
     * @param workspace_id
     * @param user
     * @param payload
     * @returns {Promise<any>}
     */
    register({ commit }, user) {

        // Call register
        return api.call(commit, 'post', `/api/workspace/${user.workspace_id}/add-user`, user, 'SET_WSUSERS');
    },

    /**
     * Update user
     * @param commit
     * @param user
     * @param payload
     * @returns {Promise<any>}
     */
    update({ commit }, wsuser) {

        // Call register
        return api.call(commit, 'patch', '/api/workspace/update-user/'+wsuser.id, wsuser, 'SET_WSUSERS');
    },

    /**
     * Delete user
     * @param commit
     * @param wsUserId
     * @param payload
     * @returns {Promise<any>}
     */
    delete({ commit }, wsUserId) {

        // Call register
        return api.call(commit, 'delete', `/api/workspace/delete-user/${wsUserId}`, false, 'DELETE_WSUSERS');
    },

    loadAllUserWorkspaces({commit}, userId) {
        return api.call(commit, 'get', `/api/workspace/${userId}/list`, false, 'SET_WSUSERS')
    }
}
